module.exports = __webpack_public_path__ + "static/media/ic-editar.55b13adb.svg";